var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Multiply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.83 38L55 52.17 52.17 55 38 40.83 23.83 55 21 52.17 35.17 38 21 23.83 23.83 21 38 35.17 52.17 21 55 23.83 40.83 38z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Multiply.edd00f33.svg";
export { SvgJ2Multiply as ReactComponent };